import React from "react";

const AdminChampionshipBracket = ({
  slotData,
  filteredTeams,
  thirdPlaceSlot,
  getM,
  handleTeamSelect,
  isTeamDisabled,
  stageIcon,
}) => {
  return (
    <div className="championship-wrapper admin-championship-wrapper">
      <div className="championship-stage-header">
        <img src={stageIcon} alt="Stage" className="stage-img" />
        <h3>Uredi Završnicu</h3>
      </div>

      <div className="championship-scroll">
        {/* 1. STUPAC: ŠESNAESTINA FINALA (Slotovi 1-8) */}
        <div className="championship-column stage-0">
          <h4 className="stage-title">Šesnaestina završnice - 1/8</h4>
          <div className="matches-grid">
            {slotData.map((slot) => {
              const m = getM(slot.id);
              return (
                <div key={slot.id} className="championship-match">
                  <div className="team admin-select-team">
                    <select
                      value={m.team_a_id || ""}
                      onChange={(e) =>
                        handleTeamSelect(slot.id, "t1", e.target.value)
                      }
                    >
                      <option value="">Odaberi</option>
                      {filteredTeams.map((t) => (
                        <option
                          key={t.id}
                          value={t.id}
                          disabled={
                            isTeamDisabled(t.id) && m.team_a_id !== t.id
                          }
                        >
                          {t.bracketLabel} - {t.name}
                        </option>
                      ))}
                    </select>
                    <span className="score">{m.scorea || 0}</span>
                  </div>
                  <div className="team admin-select-team">
                    <select
                      value={m.team_b_id || ""}
                      onChange={(e) =>
                        handleTeamSelect(slot.id, "t2", e.target.value)
                      }
                    >
                      <option value="">Odaberi</option>
                      {filteredTeams.map((t) => (
                        <option
                          key={t.id}
                          value={t.id}
                          disabled={
                            isTeamDisabled(t.id) && m.team_b_id !== t.id
                          }
                        >
                          {t.bracketLabel} - {t.name}
                        </option>
                      ))}
                    </select>
                    <span className="score">{m.scoreb || 0}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* 2. STUPAC: OSMINA FINALA (Slotovi 9-12) */}
        <div className="championship-column stage-1">
          <h4 className="stage-title">Osmina završnice - 1/4</h4>
          <div className="matches-grid">
            {[9, 10, 11, 12].map((id) => {
              const m = getM(id);
              return (
                <div key={id} className="championship-match">
                  <div className="team">
                    <span>{m.team_a?.name || "???"}</span>
                    <span className="score">{m.scorea || 0}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "???"}</span>
                    <span className="score">{m.scoreb || 0}</span>
                  </div>
                  <div className="vertical-line"></div>
                </div>
              );
            })}
          </div>
        </div>

        {/* 3. STUPAC: POLUFINALE (Slotovi 13-14) */}
        <div className="championship-column stage-2">
          <h4 className="stage-title">Polufinale - 1/2</h4>
          <div className="matches-grid">
            {[13, 14].map((id) => {
              const m = getM(id);
              return (
                <div key={id} className="championship-match">
                  <div className="team">
                    <span>{m.team_a?.name || "???"}</span>
                    <span className="score">{m.scorea || 0}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "???"}</span>
                    <span className="score">{m.scoreb || 0}</span>
                  </div>
                  <div className="vertical-line"></div>
                </div>
              );
            })}
          </div>
        </div>

        {/* 4. STUPAC: FINALE (Slot 15) */}
        <div className="championship-column stage-3 final-stage">
          <h4 className="stage-title">Finale</h4>
          <div className="final-content-wrapper">
            {(() => {
              const m = getM(15);
              return (
                <div className="championship-match finale-box">
                  <div className="team">
                    <span>{m.team_a?.name || "???"}</span>
                    <span className="score">{m.scorea || 0}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "???"}</span>
                    <span className="score">{m.scoreb || 0}</span>
                  </div>{" "}
                  <div className="vertical-line"></div>
                </div>
              );
            })()}

            <div className="trophy-container">
              <i className="fi fi-rs-trophy"></i>
              <h3>POBJEDNIK</h3>
              <div className="winner-box">
                {(() => {
                  const f = getM(15);
                  if (!f.is_completed) return "?";
                  return f.scorea > f.scoreb ? f.team_a?.name : f.team_b?.name;
                })()}
              </div>
            </div>
            {/* 3. MJESTO - Absolute ispod finala */}
            <div className="third-place-container">
              <h4 className="stage-title">3. mjesto</h4>
              <div className="matches-grid">
                {(() => {
                  const m = getM(thirdPlaceSlot);
                  return (
                    <div className="championship-match">
                      <div className="team">
                        <span>{m.team_a?.name || "???"}</span>
                        <span className="score">{m.scorea || 0}</span>
                      </div>
                      <div className="team">
                        <span>{m.team_b?.name || "???"}</span>
                        <span className="score">{m.scoreb || 0}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminChampionshipBracket;
